import React from 'react';
import { Link } from 'react-router-dom';
import Header from './Header'
import Footer from './Footer'
function NotFound() {
  return (
    <div>
         <Header></Header>
    <div style={styles.container}>
       
      <h1 style={styles.errorCode}>404</h1>
      <h2 style={styles.title}>Oops! Page Not Found</h2>
      <p style={styles.text}>
        The page you are looking for might have been removed or is temporarily unavailable.
      </p>
      <Link to="/" style={styles.button}>
        Back to Home
      </Link>
    </div>
    <Footer></Footer>
  </div>
  );
}

const styles = {
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    height: '70vh', // Adjusts height so it doesn't look cramped between header/footer
    textAlign: 'center',
    padding: '20px',
  },
  errorCode: {
    fontSize: '72px',
    margin: '0',
    color: '#333',
  },
  title: {
    fontSize: '24px',
    marginBottom: '20px',
  },
  text: {
    fontSize: '16px',
    color: '#666',
    marginBottom: '30px',
  },
  button: {
    padding: '10px 20px',
    backgroundColor: '#007bff',
    color: 'white',
    textDecoration: 'none',
    borderRadius: '5px',
    fontWeight: 'bold',
  },
};

export default NotFound;